import React from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DeliveryOrders from '../../components/datatable/orderDelivery'

export default function delivery() {
  return (
      <>
          <div className="list">
              <Sidebar />
              <div className="listContainer">
                  <Navbar />
                  <DeliveryOrders />
              </div>
          </div>
      </>
  )
}
